import React, { useEffect, useState } from "react";
import { developAxios } from "../axios.config";
import Select from "react-select";
import { Store } from "react-notifications-component";

export default function CourseTestUpdate() {
	const [allExams, setExams] = useState<Exam[]>([]);
	const [changeExam, setChangeExam] = useState<Exam>();
	const [showPass, setShowPass] = useState(false);
	const [questions, setQuestions] = useState<allQuestionsSchema[]>([]);
	const [toggleDialog, setToggleDialog] = useState({
		allquestionDialog: false,
		allCourseDialog: false,
	});
	const [allQuestions, setAllQuestions] = useState<allQuestionsSchema[]>([]);
	const [allQuestionsTemp, setAllQuestionsTemp] = useState<
		allQuestionsSchema[]
	>([]);
	const [markedQuestions, setMarkedQuestions] = useState<string[]>([]);
	const [cloneMarkedCourses, setCloneMarkedCourses] = useState<string[]>([]);
	const [checkInput, setCheckInput] = useState<boolean>(false);
	const [allCourses, setAllCourses] = useState<any[]>();

	useEffect(() => {
		developAxios(localStorage.getItem("token") || "")
			.get("/getallcourse")
			.then(({ data }) => {
				setAllCourses(data.courses);
			})
			.catch((err) => console.log(err?.response));
	}, []);
	useEffect(() => {
		if (localStorage.getItem("token")) {
			const token: any = localStorage.getItem("token");
			developAxios(token)
				.get("/getAllexam")
				.then((response) => {
					setExams(response.data.data);
				})
				.catch((error) => {
					console.error("API call error:", error);
				});
		}
	}, []);
	useEffect(() => {
		if (toggleDialog) {
			const token: any = localStorage.getItem("token");
			developAxios(token)
				.get("/GetAllQuestionAdmin")
				.then((response) => {
					setAllQuestions(response.data.questions);
					console.log(response.data.questions.length);
				});
		}
	}, []);
	useEffect(() => {
		const questionsInExam = allQuestions.filter((each) =>
			markedQuestions.includes(each._id)
		);
		setQuestions(questionsInExam);
	}, [changeExam]);
	const handleChange = (e: any) => {
		setChangeExam((prev: any) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};
	const handleQuestionSearch = (e: any) => {
		if (allQuestionsTemp.length < 1) {
			setAllQuestionsTemp(allQuestions);
		}
		const searchQuery = e.target.value.toLowerCase();
		const searchResults = allQuestionsTemp.filter((each) => {
			if (each.name) {
				return each.name.toLowerCase().includes(searchQuery);
			}
			return false;
		});
		setAllQuestions(searchResults);
	};
	const handleSave = () => {
		setChangeExam((prev: any) => ({ ...prev, questions: markedQuestions }));
		setToggleDialog((prev) => ({ ...prev, allquestionDialog: false }));
	};
	const handleMarkedQuestion = (id: string, checked: boolean) => {
		if (checked) {
			setMarkedQuestions((prev) => [...prev, id]);
		} else {
			setMarkedQuestions((prev) =>
				prev.filter((question) => question !== id)
			);
		}
		// console.log(markedQuestions);
		setCheckInput(!checkInput);
	};
	const handleMarkedCourses = (id: string, checked: boolean) => {
		if (checked) {
			setCloneMarkedCourses((prev) => [...prev, id]);
		} else {
			setCloneMarkedCourses((prev) =>
				prev.filter((question) => question !== id)
			);
		}
		setCheckInput(!checkInput);
	};
	const cloneToCourse = async (courseid: string) => {
		let exam_data = {
			loggged: changeExam?.loggged,
			isPassword: changeExam?.isPassword,
			examEndTime: changeExam?.examEndTime,
			examDate: changeExam?.examDate,
			genre: changeExam?.genre,
			name: changeExam?.name,
			questions: changeExam?.questions,
			timer: changeExam?.timer,
			courseid: courseid,
			attempts: changeExam?.attempts,
			category: changeExam?.category,
			typeOfExam: changeExam?.typeOfExam,
			language: changeExam?.language,
			type: changeExam?.type,
			topic: changeExam?.topic,
			Subtopic: changeExam?.Subtopic,
			outOfScore: changeExam?.outOfScore,
			startTime: changeExam?.startTime,
			endTime: changeExam?.endTime,
			examKey: changeExam?.examKey,
		};
		developAxios(localStorage.getItem("token") || "")
			.post("/superadmin/exams/clone-coding-exam", exam_data)
			.then((response) => {
				console.log("response");
			})
			.catch((err: any) => {
				console.log(err);
				// Store.addNotification({
				// 	title: "Exam Data Update",
				// 	message: "Something went wrong .....",
				// 	type: "danger",
				// 	insert: "top",
				// 	container: "top-right",
				// 	animationIn: ["animate__animated", "animate__fadeIn"],
				// 	animationOut: ["animate__animated", "animate__fadeOut"],
				// 	dismiss: {
				// 		duration: 5000,
				// 		onScreen: true,
				// 	},
				// });
			});
	};
	const handleCloneSubmit = async () => {
		if (cloneMarkedCourses) {
			let i = 0;
			for (i = 0; i < cloneMarkedCourses.length; i++) {
				await cloneToCourse(cloneMarkedCourses[i]);
				if (i === cloneMarkedCourses.length - 1) {
					setToggleDialog({
						allCourseDialog: false,
						allquestionDialog: false,
					});
					window.location.reload();
				}
			}
		} else {
		}
	};
	const handleSubmit = (e: any) => {
		e.preventDefault();
		const token: any = localStorage.getItem("token");
		// console.log(changeExam);
		let exam_data = {
			loggged: changeExam?.loggged,
			isPassword: changeExam?.isPassword,
			examEndTime: changeExam?.examEndTime,
			examDate: changeExam?.examDate,
			genre: changeExam?.genre,
			name: changeExam?.name,
			questions: changeExam?.questions,
			timer: changeExam?.timer,
			courseid: changeExam?.courseid._id,
			attempts: changeExam?.attempts,
			category: changeExam?.category,
			typeOfExam: changeExam?.typeOfExam,
			language: changeExam?.language,
			type: changeExam?.type,
			topic: changeExam?.topic,
			Subtopic: changeExam?.Subtopic,
			outOfScore: changeExam?.outOfScore,
			startTime: changeExam?.startTime,
			endTime: changeExam?.endTime,
			examKey: changeExam?.examKey,
		};
		if (!changeExam?.isPassword) {
			delete exam_data.examKey;
		}
		// console.log(exam_data);

		developAxios(token)
			.put(
				"/superadmin/exams/update-coding-exam/" + changeExam?._id,
				exam_data
			)
			.then((response) => {
				// console.log(response.data);

				Store.addNotification({
					title: "Exam Data Update",
					message: "Successfuly Updated !!!",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			})
			.catch((err) => {
				// console.log(err);
				Store.addNotification({
					title: "Exam Data Update",
					message: "Something went wrong .....",
					type: "danger",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			});
	};

	return (
		<>
			{!toggleDialog.allquestionDialog &&
			!toggleDialog.allCourseDialog ? (
				<div className="m-4">
					<Select
						placeholder="Select Exam ...."
						onChange={(e: any) => {
							// console.log(allExams);
							const examm = allExams.filter(
								(exam) => exam._id === e?.value
							);
							setChangeExam(examm[0]);
							// console.log(examm[0]);
							setMarkedQuestions(examm[0].questions);
						}}
						options={allExams.map((each: Exam) => {
							return { label: each.name, value: each._id };
						})}
					/>
					{changeExam ? (
						<div className="mt-6 flex flex-col  items-center justify-center ">
							<form
								onSubmit={handleSubmit}
								className="mt-6 w-[90vw] flex flex-col justify-center "
							>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Exam Name :
									</label>
									<input
										type="text"
										name="name"
										required
										value={changeExam.name}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Genre :
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="text"
										name="genre"
										value={changeExam.genre}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Timer :
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="number"
										name="timer"
										value={changeExam.timer}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Attempts:
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="number"
										name="attempts"
										value={changeExam.attempts}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Exam Date :
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										type="datetime-local"
										required
										name="examDate"
										value={(changeExam.examDate || "")
											.toString()
											.substring(0, 16)}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Exam End Time:
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="datetime-local"
										name="examEndTime"
										value={(changeExam.examEndTime || "")
											.toString()
											.substring(0, 16)}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Start Time:
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="time"
										name="startTime"
										value={changeExam.startTime || ""}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										End Time:
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="time"
										name="endTime"
										value={changeExam.endTime || ""}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Category:
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										type="text"
										required
										name="category"
										value={changeExam.category}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Type of Exam :
									</label>
									<input
										required
										type="text"
										name="typeOfExam"
										value={changeExam.typeOfExam}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Type :
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="text"
										name="type"
										value={changeExam.type}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Language :
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="text"
										name="language"
										value={changeExam.language}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Subtopic :
									</label>
									<input
										required
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										type="text"
										name="Subtopic"
										value={changeExam.Subtopic}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Out of Score :
									</label>
									<input
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										required
										type="number"
										name="outOfScore"
										value={changeExam.outOfScore}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold mb-1">
										Topic :
									</label>
									<input
										required
										className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
										type="text"
										name="topic"
										value={changeExam.topic}
										onChange={handleChange}
									/>
								</div>
								<div className="mb-4">
									<label className="block font-bold ">
										Logged :
										<input
											type="checkbox"
											className="ml-2 h-3 w-3 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
											checked={changeExam.loggged}
											onChange={(e) => {
												setChangeExam((prev: any) => ({
													...prev,
													loggged:
														!changeExam.loggged,
												}));
											}}
										/>
									</label>
								</div>
								<div className="mb-4">
									<label className="block font-bold ">
										isPassword :
										<input
											type="checkbox"
											className="ml-2 h-3 w-3 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
											checked={changeExam.isPassword}
											onChange={(e) => {
												setChangeExam((prev: any) => ({
													...prev,
													isPassword:
														!changeExam.isPassword,
												}));
											}}
										/>
									</label>
								</div>
								{changeExam.isPassword ? (
									<>
										<div className="mb-4">
											<label className="block font-bold ">
												Password :
												<input
													className="px-3 ml-4 py-2 border inline max-w-[14rem] rounded-md focus:outline-none focus:border-blue-500"
													required
													type={
														showPass
															? "text"
															: "password"
													}
													value={changeExam.examKey}
													onChange={(e) => {
														setChangeExam(
															(prev: any) => ({
																...prev,
																examKey:
																	e.target
																		.value,
															})
														);
													}}
												/>
												<button
													type="button"
													onClick={(e) => {
														setShowPass(!showPass);
													}}
													style={{
														backgroundColor:
															"rgb(248 113 113 / var(--tw-bg-opacity))",
													}}
													className="ml-2 p-2 rounded-lg bg-red-400"
												>
													{showPass ? "Hide" : "Show"}
												</button>
											</label>
										</div>
									</>
								) : (
									<></>
								)}

								<div className="mb-4">
									<label className="flex justify-between items-center w-full">
										Questions of Exam:
										<button
											type="button"
											style={{
												backgroundColor:
													"rgb(147 197 253 / var(--tw-bg-opacity))",
											}}
											onClick={(e) => {
												setToggleDialog((prev) => ({
													...prev,
													allquestionDialog: true,
												}));
											}}
											className="p-2 bg-blue-300 flex flex-row gap-1"
										>
											<svg
												width="20"
												height="20"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<g
													id="SVGRepo_bgCarrier"
													stroke-width="0"
												></g>
												<g
													id="SVGRepo_tracerCarrier"
													stroke-linecap="round"
													stroke-linejoin="round"
												></g>
												<g id="SVGRepo_iconCarrier">
													{" "}
													<path
														opacity="0.15"
														d="M4 20H8L18 10L14 6L4 16V20Z"
														fill="#000000"
													></path>{" "}
													<path
														d="M18 10L21 7L17 3L14 6M18 10L8 20H4V16L14 6M18 10L14 6"
														stroke="#000000"
														stroke-width="1.5"
														stroke-linecap="round"
														stroke-linejoin="round"
													></path>{" "}
												</g>
											</svg>
											Edit Questions
										</button>
									</label>
									<div>
										{changeExam.questions.length > 0 ? (
											<table className="border w-full">
												<thead className="bg-dark text-white">
													<tr>
														<th className="py-2 text-center">
															S.No
														</th>
														<th className="py-2 text-center">
															Questions
														</th>
														<th className="py-2 text-center">
															Topic
														</th>
													</tr>
												</thead>
												<tbody>
													{questions ? (
														questions.map(
															(each, index) => {
																return (
																	<tr
																		key={
																			each._id
																		}
																	>
																		<td className="border text-center py-2 text-center">
																			{index +
																				1}
																			.
																		</td>
																		<td className="border text-center py-2">
																			{
																				each.name
																			}
																		</td>
																		<td className="border text-center py-2">
																			{
																				each.category
																			}
																		</td>
																	</tr>
																);
															}
														)
													) : (
														<>
															<div>
																hihakkadha
															</div>
														</>
													)}
												</tbody>
											</table>
										) : (
											<div className="font-extrabold text-lg">
												No. Questions Found
											</div>
										)}
									</div>
								</div>
								<div className="flex my-2 gap-4 flex-row items-center justify-center">
									<button
										style={{
											backgroundColor:
												" rgb(22 163 74 / var(--tw-bg-opacity))",
										}}
										className="p-2 mt-3 font-bold text-white mb-10 bg-green-600 "
										type="submit"
									>
										Update Exam
									</button>
									<button
										type="button"
										style={{ backgroundColor: "blue" }}
										className="p-2 mt-3 font-bold text-white mb-10 "
										onClick={(e) => {
											setToggleDialog((prev) => ({
												...prev,
												allCourseDialog: true,
											}));
										}}
									>
										Clone Exam
									</button>
								</div>
							</form>
						</div>
					) : (
						<></>
					)}
				</div>
			) : (
				<dialog
					open={toggleDialog.allquestionDialog}
					className={
						"fixed top-0 w-screen h-screen bg-white justify-center items-center bg-transparent backdrop-blur-sm p-6"
					}
				>
					<div className=" flex w-full mb-2 mt-4 justify-center items-center flex-row gap-2">
						<button
							onClick={handleSave}
							style={{
								backgroundColor:
									" rgb(22 163 74 / var(--tw-bg-opacity))",
							}}
							className="relative p-2 top-1 left-1 flex flex-row border-black border-[1px]  justify-center items-center"
							type="button"
						>
							<svg
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									{" "}
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M18.1716 1C18.702 1 19.2107 1.21071 19.5858 1.58579L22.4142 4.41421C22.7893 4.78929 23 5.29799 23 5.82843V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H18.1716ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21L5 21L5 15C5 13.3431 6.34315 12 8 12L16 12C17.6569 12 19 13.3431 19 15V21H20C20.5523 21 21 20.5523 21 20V6.82843C21 6.29799 20.7893 5.78929 20.4142 5.41421L18.5858 3.58579C18.2107 3.21071 17.702 3 17.1716 3H17V5C17 6.65685 15.6569 8 14 8H10C8.34315 8 7 6.65685 7 5V3H4ZM17 21V15C17 14.4477 16.5523 14 16 14L8 14C7.44772 14 7 14.4477 7 15L7 21L17 21ZM9 3H15V5C15 5.55228 14.5523 6 14 6H10C9.44772 6 9 5.55228 9 5V3Z"
										fill="#0F0F0F"
									></path>{" "}
								</g>
							</svg>
							Save
						</button>
						<button
							type="button"
							style={{
								backgroundColor:
									"rgb(239 68 68 / var(--tw-bg-opacity))",
							}}
							className="relative p-2 top-1 left-1 flex flex-row border-black border-[1px]  justify-center items-center"
							onClick={(e) => {
								setToggleDialog((prev) => ({
									...prev,
									allquestionDialog: false,
								}));
							}}
						>
							Close
							<svg
								height="32"
								width="32"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									{" "}
									<path
										d="M10.0303 8.96967C9.73741 8.67678 9.26253 8.67678 8.96964 8.96967C8.67675 9.26256 8.67675 9.73744 8.96964 10.0303L10.9393 12L8.96966 13.9697C8.67677 14.2626 8.67677 14.7374 8.96966 15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303 13.9697L13.0606 12L15.0303 10.0303C15.3232 9.73746 15.3232 9.26258 15.0303 8.96969C14.7374 8.6768 14.2625 8.6768 13.9696 8.96969L12 10.9394L10.0303 8.96967Z"
										fill="#1C274C"
									></path>{" "}
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
										fill="#1C274C"
									></path>{" "}
								</g>
							</svg>
						</button>
					</div>
					<div className=" overflow-y-scroll mx-auto w-[90vw] h-[60vh] ">
						<div className="w-full p-1 flex justify-center items-center  bg-black">
							<input
								type="search"
								placeholder="Search Questions ...."
								className="py-2 px-4 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
								onChange={handleQuestionSearch}
							/>
						</div>
						<table className="border bg-blue-200 w-full">
							<thead className="bg-dark text-white">
								<tr>
									<th className="py-2 text-center">
										Select Questions
									</th>
									<th className="py-2 text-center">
										Questions
									</th>
									<th className="py-2 text-center">Topic</th>
								</tr>
							</thead>
							<tbody>
								{allQuestions ? (
									allQuestions.map((each) => {
										let check: boolean = false;
										if (
											markedQuestions.includes(each._id)
										) {
											check = true;
										}
										return (
											<tr key={each._id}>
												<td className="border text-center py-2 ">
													<input
														checked={check}
														onChange={(e) =>
															handleMarkedQuestion(
																each._id,
																e.target.checked
															)
														}
														type="checkbox"
														className="h-5 w-5"
													/>
												</td>
												<td className="border text-center py-2">
													{each.name}
												</td>
												<td className="border text-center py-2">
													{each.category}
												</td>
											</tr>
										);
									})
								) : (
									<div>Wait....</div>
								)}
							</tbody>
						</table>
					</div>
				</dialog>
			)}
			{toggleDialog.allCourseDialog ? (
				<dialog
					open={toggleDialog.allCourseDialog}
					className={
						"bg-white fixed top-0 w-screen h-screen justify-center items-center bg-transparent backdrop-blur-sm p-6"
					}
				>
					<div className=" flex w-full mb-2 mt-4 justify-center items-center flex-row gap-2">
						<button
							style={{
								backgroundColor:
									"rgb(96 165 250 / var(--tw-bg-opacity))",
							}}
							onClick={handleCloneSubmit}
							className="relative p-2 bg-blue-400 top-1 left-1 flex flex-row border-black border-[1px]  justify-center items-center"
							type="button"
						>
							<svg
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									{" "}
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M18.1716 1C18.702 1 19.2107 1.21071 19.5858 1.58579L22.4142 4.41421C22.7893 4.78929 23 5.29799 23 5.82843V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H18.1716ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21L5 21L5 15C5 13.3431 6.34315 12 8 12L16 12C17.6569 12 19 13.3431 19 15V21H20C20.5523 21 21 20.5523 21 20V6.82843C21 6.29799 20.7893 5.78929 20.4142 5.41421L18.5858 3.58579C18.2107 3.21071 17.702 3 17.1716 3H17V5C17 6.65685 15.6569 8 14 8H10C8.34315 8 7 6.65685 7 5V3H4ZM17 21V15C17 14.4477 16.5523 14 16 14L8 14C7.44772 14 7 14.4477 7 15L7 21L17 21ZM9 3H15V5C15 5.55228 14.5523 6 14 6H10C9.44772 6 9 5.55228 9 5V3Z"
										fill="#0F0F0F"
									></path>{" "}
								</g>
							</svg>
							Clone to Courses
						</button>
						<button
							type="button"
							style={{
								backgroundColor:
									"rgb(239 68 68 / var(--tw-bg-opacity))",
							}}
							className="relative p-2 top-1 left-1 flex flex-row border-black border-[1px]  justify-center items-center"
							onClick={(e) => {
								setToggleDialog((prev) => ({
									...prev,
									allCourseDialog: false,
								}));
							}}
						>
							Close
							<svg
								height="32"
								width="32"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
								<g
									id="SVGRepo_tracerCarrier"
									stroke-linecap="round"
									stroke-linejoin="round"
								></g>
								<g id="SVGRepo_iconCarrier">
									{" "}
									<path
										d="M10.0303 8.96967C9.73741 8.67678 9.26253 8.67678 8.96964 8.96967C8.67675 9.26256 8.67675 9.73744 8.96964 10.0303L10.9393 12L8.96966 13.9697C8.67677 14.2626 8.67677 14.7374 8.96966 15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303 13.9697L13.0606 12L15.0303 10.0303C15.3232 9.73746 15.3232 9.26258 15.0303 8.96969C14.7374 8.6768 14.2625 8.6768 13.9696 8.96969L12 10.9394L10.0303 8.96967Z"
										fill="#1C274C"
									></path>{" "}
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
										fill="#1C274C"
									></path>{" "}
								</g>
							</svg>
						</button>
					</div>
					<div className=" overflow-y-scroll mx-auto w-[70vw] max-h-[60vh] ">
						<table className="border bg-blue-200 w-full">
							<thead className="bg-dark text-white">
								<tr>
									<th className="py-2 text-center">
										Select Courses
									</th>
									<th className="py-2 text-center">
										Course Name
									</th>
								</tr>
							</thead>
							<tbody>
								{allCourses ? (
									allCourses.map((each) => {
										let check: boolean = false;
										if (
											cloneMarkedCourses.includes(
												each._id
											)
										) {
											check = true;
										}
										return (
											<tr key={each._id}>
												<td className="border text-center py-2 ">
													<input
														checked={check}
														onChange={(e) =>
															handleMarkedCourses(
																each._id,
																e.target.checked
															)
														}
														type="checkbox"
														className="h-5 w-5"
													/>
												</td>
												<td className="border text-center py-2">
													{each.name}
												</td>
											</tr>
										);
									})
								) : (
									<div>Wait....</div>
								)}
							</tbody>
						</table>
					</div>
				</dialog>
			) : (
				<></>
			)}
		</>
	);
}
interface Exam {
	loggged: boolean;
	isPassword: boolean;
	examDate: string;
	_id: string;
	name: string;
	questions: string[];
	timer: string;
	courseid: {
		_id: string;
		name: string;
	};
	attempts: number;
	category: string;
	typeOfExam: string;
	language: string;
	type: string;
	topic: string;
	Subtopic: string;
	outOfScore: number;
	__v: number;
	examEndTime: string;
	genre: string;
	startTime: string;
	endTime: string;
	examKey: string;
}

interface allQuestionsSchema {
	_id: string;
	name: string;
	questionWeight: number;
	outOfScore: number;
	category: string;
	company: any[]; // You can replace 'any' with a more specific type if available
}
